<div class="productDetailsTitle">
  <h2>{{title}}</h2>
  <h4>
    <span>{{computeGender(gender) | translate}} {{computeType(type) | translate}} {{brand}}</span>
    <br><span *ngIf="collection">{{collection}}, </span><span *ngIf="selectedVariantName">{{selectedVariantName}}, </span><span class="productDetailsTitle__ref" *ngIf="manufacturerProductName">Ref: {{manufacturerProductName}}</span>
  </h4>
</div>
